import React from 'react'
import { Outlet } from 'react-router-dom'
import {Box} from '@mui/material'


const AuthLayout = () => {
	return (
		<Box sx={{
			width: '100%',
			height: '100vh',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		}}>
			<Outlet />
		</Box>
	)
}

export default AuthLayout